import React, { useState } from 'react';
import { contentfulPropTypes, netZeroPropTypes } from '../../propTypes';
import {
  getAnnualCarEmissions,
  getCarEmissions,
} from '../../utils/netZeroHelper';

import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LoginCard } from '../../ui';
import RemoveCarModal from '../../ui/Modal/RemoveCarModal';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import withContentfulTag from '../../utils/withContentfulTag';

const StyledDiv = styled.div`
  border: 1px solid #afb6b9;
  border-radius: 4px;
  margin: 10px 0 20px;

  div:last-child {
    border-bottom: none;
  }
`;

const StyledData = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 15px;
  padding: 15px 0 14px;
  border-bottom: 1px solid #afb6b9;
`;

const StyledLabel = styled.span`
  color: #afb6b9;
`;

const StyledValue = styled.span`
  font-weight: bold;
`;

const EmissionsContainer = ({
  contentful,
  loading,
  fetched,
  cars,
  setCars,
}) => {
  const navigate = useNavigate();
  const [numberPlateForRemoval, setNumberPlateForRemoval] = useState(undefined);

  const onRemoveCar = async numberPlate => {
    const trimmedCars = [];
    cars.forEach(car => {
      if (car.numberPlate !== numberPlate) {
        trimmedCars.push(car);
      }
    });
    setNumberPlateForRemoval(undefined);
    setCars(trimmedCars);
  };

  if (!cars?.length) {
    navigate('/net-zero/car');
  }

  return (
    !loading &&
    fetched && (
      <>
        <RemoveCarModal
          numberPlate={numberPlateForRemoval}
          onRemoveCar={onRemoveCar}
          onClose={() => setNumberPlateForRemoval(undefined)}
        />
        <LoginCard onBack={() => navigate('/net-zero/car')}>
          <p>
            Step <strong>4</strong> of <strong>4</strong>
          </p>
          <h1 className="pb-3 px-5">{contentful.title}</h1>
          {cars.map((car, index) => (
            <div key={`car-${index}`} className="text-left">
              <div className="d-flex justify-content-between">
                <span className="font-weight-bold">{car.numberPlate}</span>
                <Button
                  variant="link"
                  className="p-0"
                  onClick={() => setNumberPlateForRemoval(car.numberPlate)}>
                  {contentful.utilityText}
                </Button>
              </div>
              <StyledDiv>
                <StyledData>
                  <StyledLabel>Vehicle make</StyledLabel>
                  <StyledValue>{car.details.make}</StyledValue>
                </StyledData>
                <StyledData>
                  <StyledLabel>CO2 emissions</StyledLabel>
                  <StyledValue>
                    {getCarEmissions(
                      car.details.fuelType,
                      car.details.co2Emissions,
                    )}{' '}
                    g/mi
                  </StyledValue>
                </StyledData>
                <StyledData>
                  <StyledLabel>Annual mileage</StyledLabel>
                  <StyledValue>{car.annualMileage}</StyledValue>
                </StyledData>
                <StyledData>
                  <StyledLabel>Annual CO2 emissions</StyledLabel>
                  <StyledValue>
                    {getAnnualCarEmissions(
                      car.details.fuelType,
                      car.annualMileage,
                      car.details.co2Emissions,
                    )}{' '}
                    tons
                  </StyledValue>
                </StyledData>
              </StyledDiv>
            </div>
          ))}
          <Button
            className="mb-3"
            onClick={() => navigate('/net-zero/how-to-with-loop')}>
            Next
          </Button>
          <Button variant="secondary" onClick={() => navigate('/net-zero/car')}>
            <FontAwesomeIcon icon={faPlusCircle} />
            Add another car
          </Button>
        </LoginCard>
      </>
    )
  );
};

EmissionsContainer.propTypes = {
  ...contentfulPropTypes,
  ...netZeroPropTypes,
};

export default withContentfulTag(
  EmissionsContainer,
  'web_app_netzero_emissions_page',
);
